<template lang="pug">
div
  app-divider.negative-margin-top.margin-bottom(
    label="Cálculo de Custas",
    v-if="exibirLabelCustas"
  )
  el-row.margin-medium-top(:gutter="20")
    el-col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }")
        app-label(
          label="Diárias: ",
          :required="true"
        )
        el-input-number.input(
          type="number",
          size="large",
          :min="1",
          v-model='custa.numeroDiarias'
          name="diárias",
          :disabled="disableCadastrarCustas"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8", v-if="exibirDataVencimento")
      validation-provider(rules="required", v-slot="{ errors }", v-if="exibirDataVencimento")
        app-label.input-default(label="Data de vencimento:")
        el-date-picker.input.full-width(
          :class="{'erro' : errors.length}",
          name="data",
          v-model='custa.dataVencimento',
          type='date',
          placeholder='Selecione'
          v-bind="$attrs",
          format="dd/MM/yyyy"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8" v-if="exibirFatorLocalizacao")
      validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Município:")
          el-select.full-width.input(
            v-model='idMunicipio'
            :class="{'erro' : errors.length}"
            @change="changeFatorLocalizacao"
          )
            el-option(
                v-for='municipio in municipios'
                :key='municipio.id',
                :label='municipio.nome'
                :value='municipio.id'
            )
          span.help.erro {{ errors[0] }}
  el-row.margin-medium-top(:gutter="20")
    el-col(:xl="8" :lg="8")
      .body-component
        el-card.sizeCard
          div(slot="header", class="clearfix")
            span.subtitle Diárias do Motorista
          .pad
            el-row
              el-col
              app-label.label-diaria(
                label="Valor da diária:"
              )
            el-row
              validation-provider(rules="required|min_value:0.01", v-slot="{ errors }")
                app-double-input.input(
                  :hasValidationError="errors[0] ? true : false"
                  v-model="custa.valorMotorista.valor"
                  :disable="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            el-row
              app-label.label-funcionarios(
                label="Número de funcionários:",
              )
            el-row
              validation-provider(rules="required", v-slot="{ errors }")
                el-input-number.input(
                  type="number",
                  controls-position="right"
                  size="small"
                  :min="1"
                  v-model="custa.valorMotorista.quantidade"
                  name="nº de funcionários"
                  :disabled="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            app-display(label="Custo Diárias (por funcionário): ", :required="false", :content="totalMotoristaPorFuncionario")
            app-display(label="Total Custo Pessoal: ", :required="false", :content="totalMotorista")
    el-col(:xl="8" :lg="8", v-if="!credenciadoVistoria")
      .body-component
        el-card.sizeCard(v-if="!credenciadoVistoria")
          div(slot="header", class="clearfix")
            span.subtitle Diárias de Vistoria
          .pad
            el-row
              el-col
              app-label.label-diaria(
                label="Valor da diária:"
              )
            el-row
              validation-provider(rules="required|min_value:0.01", v-slot="{ errors }")
                app-double-input.input(
                  :hasValidationError="errors[0] ? true : false"
                  v-model="custa.valorVistoria.valor"
                  :disable="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            el-row
              app-label.label-funcionarios(
                label="Número de funcionários:",
              )
            el-row
              validation-provider(rules="required", v-slot="{ errors }")
                el-input-number.input(
                  type="number",
                  controls-position="right"
                  size="small"
                  :min="1"
                  v-model="custa.valorVistoria.quantidade"
                  name="nº de funcionários"
                  :disabled="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            app-display.label-custas(label="Custo Diárias (por funcionário): ", :required="false", :content="totalVistoriaPorFuncionario")
            app-display.label-custas(label="Total Custo Pessoal: ", :required="false", :content="totalVistoria")
    el-col(:xl="8" :lg="8", v-if="!credenciadoGeomensor && processo.tipoCodigo!=='CERTIDAO_TITULO'")
      .body-component
        el-card.sizeCard(v-if="!credenciadoGeomensor && processo.tipoCodigo!=='CERTIDAO_TITULO'")
          div(slot="header", class="clearfix")
            span.subtitle Diárias de Demarcação e Fiscalização
          .pad
            el-row
              el-col
              app-label.label-diaria(
                label="Valor da diária:"
              )
            el-row
              validation-provider(rules="required|min_value:0.01", v-slot="{ errors }")
                app-double-input.input(
                  :hasValidationError="errors[0] ? true : false"
                  v-model="custa.valorDemarcacao.valor"
                  :disable="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            el-row
              app-label.label-funcionarios(
                label="Número de funcionários:",
              )
            el-row
              validation-provider(rules="required", v-slot="{ errors }")
                el-input-number.input(
                  type="number",
                  controls-position="right"
                  size="small"
                  :min="1"
                  v-model="custa.valorDemarcacao.quantidade"
                  name="nº de funcionários"
                  :disabled="disableCadastrarCustas"
                )
                span.help.erro {{ errors[0] }}
            app-display.label-custas(label="Custo Diárias (por funcionário): ", :required="false", :content="totalDemarcacaoPorFuncionario")
            app-display.label-custas(label="Total Custo Pessoal: ", :required="false", :content="totalDemarcacao")
        el-row.margin-medium-top(:gutter="20")
  el-row.margin-medium-top(:gutter="20")
    el-col(:xl="8" :lg="8")
      app-display(
        v-if="exibirElaboracaoPublicacao"
        label="Elaboração/Publicação do edital que torna pública à alienação: ",
        :content="valorFixoEditalAlienacaoPublicaFormatado"
      )
      app-display(
        v-if="exibirFatorLocalizacao"
        label="Fator de localização: ",
        :content="custa.fatorLocalizacao"
      )
      div(v-if="exibirNumeroModulos")
        validation-provider(rules="required", v-slot="{ errors }", v-if="exibirNumeroModulos")
          app-label.label-diaria(
            label="Número de módulos:",
          )
          el-input-number.input(
            type="number",
            size="small"
            :min="1"
            controls-position="right"
            v-model="custa.numeroModulos"
            name="nº de módulos",
            :disabled="disableCadastrarCustas"

          )
          span.help.erro {{ errors[0] }}
      app-display.totalLabel(label="TOTAL À PAGAR:", :content="valorTotalCustas")
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import utils from '@/utils/utils'
import AppLabel from '@/components/AppLabel.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import AppDoubleInput from '@/components/AppDoubleInput.vue'
const { fatoresLocalizacao, disableCadastrarCustas } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppDoubleInput,
    AppDisplay,
    AppDivider,
    AppLabel
  },

  props: {
    custa: {
      required: true
    },
    exibirLabelCustas: {
      type: Boolean,
      default: false
    },
    exibirNumeroModulos: {
      type: Boolean,
      default: true
    },
    exibirFatorLocalizacao: {
      type: Boolean,
      default: false
    },
    exibirElaboracaoPublicacao: {
      type: Boolean,
      default: true
    },
    exibirDataVencimento: {
      type: Boolean,
      default: true
    },
    valoresFixos: {
      type: Array
    },
    credenciadoVistoria: {
      type: Boolean
    },
    credenciadoGeomensor: {
      type: Boolean
    },
    processo: {
      type: Object
    }
  },

  data () {
    return {
      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      idMunicipio: null,
      municipios: []
    }
  },

  async created () {
    this.municipios = (await this.findMunicipiosByEstadoAtual()) || []
    this.idMunicipio = this.custa.municipio?.id
  },

  computed: {
    totalMotoristaPorFuncionario () {
      return this.totalPorFuncionario('valorMotorista')
    },
    totalMotorista () {
      return this.totalPessoal('valorMotorista')
    },
    totalVistoriaPorFuncionario () {
      return this.totalPorFuncionario('valorVistoria')
    },
    totalVistoria () {
      return this.totalPessoal('valorVistoria')
    },
    totalDemarcacaoPorFuncionario () {
      return this.totalPorFuncionario('valorDemarcacao')
    },
    totalDemarcacao () {
      return this.totalPessoal('valorDemarcacao')
    },
    valorFixoEditalAlienacaoPublica () {
      const valorFixo = _.find(this.valoresFixos, ['codigo', 'ELABORACAO_EDITAL'])
      return (valorFixo ? valorFixo.valor : 0) * this.custa.numeroModulos
    },
    valorFixoEditalAlienacaoPublicaFormatado () {
      return ` R$ ${utils.format(this.valorFixoEditalAlienacaoPublica)}`
    },
    valorTotalCustas () {
      return `R$ ${utils.format(this.valorTotal())}`
    },
    disableCadastrarCustas () {
      return disableCadastrarCustas
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise'
    }),
    totalPorFuncionario (tipo) {
      const result = this.custa.numeroDiarias * this.custa[tipo].valor
      return `R$ ${utils.format(result)}`
    },
    valorTotal () {
      this.custa.valorTotal =
        (this.custa.valorMotorista.total +
          this.custa.valorVistoria.total +
          this.custa.valorDemarcacao.total +
          this.valorFixoEditalAlienacaoPublica) * (this.custa.fatorLocalizacao || 1)
      return this.custa.valorTotal
    },
    totalPessoal (tipo) {
      const total = this.custa[tipo].valor * this.custa[tipo].quantidade
      this.custa[tipo].total = this.custa.numeroDiarias * total
      return `R$ ${utils.format(this.custa[tipo].total)}`
    },
    diariaMotorista () {
      this.diaria('valorMotorista', 'DIARIA_MOTORISTA')
    },
    diariaVistoria () {
      this.diaria('valorVistoria', 'DIARIA_VISTORIA')
    },
    diariaDemarcacao () {
      this.diaria('valorDemarcacao', 'DIARIA_DEMARCACAO_FISCALIZACAO')
    },
    changeFatorLocalizacao () {
      this.custa.municipio = { id: this.idMunicipio }
      this.custa.fatorLocalizacao = fatoresLocalizacao[this.idMunicipio]
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-medium-top {
  margin-top: 20px;
}

.right {
  float: right;
}

.body-component {
  padding-top: 20px;
}

.label-diaria {
  display: inline-block;
  padding-right: 10px;
  font-weight: bold;
}

.label-funcionarios {
  padding-top: 8px;
  margin: 2px 2px 2px 2px;
  font-weight: bold;
}

.label-custas {
  margin-top: 10px;
}

.negative-margin-top {
  margin-top: -25px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppGeracaoCustas.vue